import React from "react";
import { useSupportAuth } from "../context/SupportAuthContext";

const SupportDashboard = () => {
  const { supportEmail, forcedLogoutReason } = useSupportAuth();

  return (
    <div className="bg-white border rounded-md p-5">
      {forcedLogoutReason ? (
        <div className="rounded-md border border-red-200 bg-red-50 text-red-700 p-3 text-sm mb-3">
          {forcedLogoutReason}
        </div>
      ) : null}
      <h2 className="text-xl font-semibold mb-1">Welcome</h2>
      <p className="text-sm text-gray-600">
        Logged in as <span className="font-medium">{supportEmail || "Support User"}</span>.
      </p>
      <p className="text-sm text-gray-500 mt-2">
        Use the left sidebar to access only the modules approved by admin.
      </p>
    </div>
  );
};

export default SupportDashboard;

